import React, { useEffect, useState } from "react";

// Magic components
import MagicDrawer from "../components/common/MagicDrawer_new";

// @mui
import Stack from "../components/mui/Stack";
import Button from "../components/mui/Button";
import ImageComponent from "../components/mui/Image";

import ReportFilterForm, {
  CityType,
  FilterStateType,
} from "../components/Report/ReportFilterForm";
import Tabs from "../components/targetAchivment/Tabs";
import SelectedTable from "../components/Report/SelectedTable ";

// APIs
import {
  useCenterListQuery,
  useFetchedFunderQuery,
  useFetchedProgramTypesQuery,
  useFetchRegionQuery,
  useUserListQuery,
} from "../store/apis/centerApis";
import { useFetchManageAwardQuery } from "../store/apis/reportsApis";
import { State, City } from "country-state-city";
import { useSelector } from "react-redux";
import { RootState } from "../../src/store";
interface TabCategory {
  id: number;
  name: string;
  code: string;
}
interface IndianCity {
  label: string;
  id: string;
}

type Cities = IndianCity[];

const dummyTabCategories: TabCategory[] = [
  { id: 1, name: "Enrolment", code: "ENROLMENT" },
  { id: 2, name: "Attendance", code: "ATTENDANCE_SUMMARY_REPORT" },
  { id: 3, name: "Drop Out", code: "DROP_OUT" },
  { id: 4, name: "Placement", code: "PLACEMENT" },
  { id: 5, name: "Demand Driven Placement", code: "DEMAND_DRIVEN_PLACEMENT" },
  { id: 6, name: "Retention", code: "RETENTION" },
  { id: 7, name: "Operations finance", code: "OPERATIONS_FINANCE" },
  { id: 8, name: "Operations HR", code: "OPERATIONS_HR" },
  { id: 9, name: "Governance and ethics", code: "GOVERNANCE_AND_ETHICS" },
  { id: 10, name: "Session Qualty", code: "SESSION_QUALITY" },
  { id: 11, name: "Stakeholders feedback", code: "STAKEHOLDERS_FEEDBACK" },
  { id: 12, name: "Center visit/Branding", code: "CENTER_VISIT_BRANDING" },
  { id: 13, name: "Staff Training", code: "STAFF_TRAINING" },
];

const SummaryReportContainer: React.FC = () => {
  const initialFilterState: FilterStateType = {
    regions: [],
    selectedRegion: [],
    center: null,
    programPerformanceParameter: null,
    qualityEfficacyParameter: null,
    state: null,
    city: null,
    funder: null,
    regionalDataManager: null,
    cityManager: null,
    clusterManager: null,
    medals: null,
    programMasterId: null,
    ProgramYearId: null,
    quarterMasterId: null,
  };
  const filterData = useSelector((state: RootState) => state?.user?.filter);
  const [isOpenFilterForm, setIsOpenFilterForm] = useState<boolean>(false);
  const [selectedTab, setSelectedTab] = useState<TabCategory | null>(
    dummyTabCategories.find((tab) => tab.code === "ENROLMENT") || null
  );
  const [isLessThen3Value, setIsLessThen3Value] = useState<boolean>(false);
  const [filter, setFilter] = useState({
    ...initialFilterState,
  });
  const [params, setParams] = useState<{
    [key: string]: number | string | undefined;
  }>({
    programMasterId: filterData?.selectedProgram?.value || undefined,
    quarterMasterId: filterData?.selectedQuarter?.quarterMasterId || undefined,
    ProgramYearId: filterData?.selectedYear?.value || undefined,
  });
  const [cities, setCities] = useState<Cities>([]);
  useEffect(() => {
    const paramObj: { [key: string]: number | string | undefined } = {
      programMasterId: filterData?.selectedProgram?.value,
      ProgramYearId: filterData?.selectedYear?.value,
    };
    if (filterData?.selectedQuarter?.quarterMasterId) {
      paramObj.quarterMasterId = filterData.selectedQuarter.quarterMasterId;
    }
    setParams(paramObj);
  }, [filterData]);
  const toggleFilerFormDrawer = () => {
    setIsOpenFilterForm((preState) => !preState);
  };
  const handleCategoryChange = (id: number) => {
    const selectedCategory = dummyTabCategories.find(
      (category) => category.id === id
    );
    if (selectedCategory) {
      setSelectedTab(selectedCategory);
      setFilter({ ...initialFilterState });
      setParams({
        pageNo: "1",
        pageSize: "10",
        programMasterId: filterData?.selectedProgram?.value || undefined,
        quarterMasterId:
          filterData?.selectedQuarter?.quarterMasterId || undefined,
        ProgramYearId: filterData?.selectedYear?.value || undefined,
        search: undefined,
      });
    } else {
      console.log("Category not found for ID:", id);
    }
  };
  const preparePayload = (filter: FilterStateType) => {
    const {
      regions,
      selectedRegion,
      center,
      programPerformanceParameter,
      qualityEfficacyParameter,
      state,
      city,
      funder,
      regionalDataManager,
      cityManager,
      clusterManager,
      medals,
    } = filter;
    const parseRegion = (regions: any) =>
      regions.map((r: any) => r.id).join(",");
    const payload: any = {
      pageNo: "1",
      pageSize: "10",
      regions: regions.length > 0 ? regions.join(",") : undefined,
      region: parseRegion(selectedRegion) || undefined,
      center: center?.id,
      programPerformanceParameter: programPerformanceParameter?.id,
      qualityEfficacyParameter: qualityEfficacyParameter?.id,
      state: state?.label,
      district: city?.label,
      funder: funder?.id,
      regionalDataManagerUserId: regionalDataManager?.id,
      cityManagerUserId: cityManager?.id,
      clusterManagerUserId: clusterManager?.id,
      programMasterId: filterData?.selectedProgram?.value || undefined,
      quarterMasterId:
        filterData?.selectedQuarter?.quarterMasterId || undefined,
      ProgramYearId: filterData?.selectedYear?.value || undefined,
      medals: medals?.id,
    };

    return payload;
  };
  const handleApplyFilterBtn = (): void => {
    try {
      setParams(preparePayload(filter));
      setIsOpenFilterForm((prevState) => !prevState);
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleClearAllFilterBtn = (): void => {
    setFilter({ ...initialFilterState });
    setParams({
      programMasterId: filterData?.selectedProgram?.value || undefined,
      quarterMasterId:
        filterData?.selectedQuarter?.quarterMasterId || undefined,
      ProgramYearId: filterData?.selectedYear?.value || undefined,
      pageNo: "1",
      pageSize: "10",
      search: undefined,
    });
  };
  const handlePagination = (pageNo: number) => {
    setParams((prev) => ({ ...prev, pageNo }));
  };
  const handleReportSearch = (value: string | number) => {
    const searchValue = typeof value === "number" ? value.toString() : value;
    const isLessThan3 = searchValue.length > 0 && searchValue.length < 3;
    setIsLessThen3Value(isLessThan3);
    if (searchValue.length >= 3) {
      setParams((prev) => ({ ...prev, pageNo: 1, search: searchValue }));
    } else if (searchValue.length === 0) {
      setParams({
        pageNo: "1",
        pageSize: "10",
        programMasterId: filterData?.selectedProgram?.value || undefined,
        quarterMasterId:
          filterData?.selectedQuarter?.quarterMasterId || undefined,
        ProgramYearId: filterData?.selectedYear?.value || undefined,
        search: undefined,
      });
    }
  };

  const magicPageHeaderBtn = [
    {
      text: "Download",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/login/exportIcon.svg"
          alt="AddIcon"
        />
      ),
      sx: {
        background: "white",
        border: "1px solid #D0D5DD", // Corrected here
        borderRadius: "8px",
        color: "black",
      },
    },
  ];

  const magicTableHeaderBtn = [
    {
      text: "Add Filters",
      variant: "outlined",
      startIcon: (
        <ImageComponent
          src="/assets/images/login/addFilterIcon.svg"
          alt="AddFilterIcon"
        />
      ),
      onClick: toggleFilerFormDrawer,
      sx: {
        background: "white",
        border: "1px solid #D0D5DD",
        borderRadius: "8px",
        color: "black",
      },
    },
  ];

  const ratiobtn = [
    { label: "All", value: "all" },
    { label: "East", value: "east" },
    { label: "West", value: "west" },
    { label: "North", value: "north" },
    { label: "South", value: "south" },
  ];
  const handleFilterFormChange = (field: string, value: any) => {
    if (field === "state") {
      const indianCities: IndianCity[] = value?.id
        ? City.getCitiesOfState("IN", value?.id).map((city) => ({
            label: city.name,
            id: city.stateCode,
          }))
        : [];
      setCities(indianCities);
    }
    setFilter((prevFilter: any) => ({
      ...prevFilter,
      [field]: value,
    }));
  };

  // APIs calling

  const { data: centerList = {} } = useCenterListQuery(
    {
      state: filter.state ? filter?.state?.label : undefined,
      district: filter.city ? filter?.city?.label : undefined,
      region: filter.regions ? filter?.regions : undefined,
      pageNo: "1",
      pageSize: "10000",
    },
    { refetchOnMountOrArgChange: true }
  );
  const { data: cityManager = [] } = useUserListQuery({ roleId: "4" });
  const { data: clusterManager = [] } = useUserListQuery({ roleId: "5" });
  const { data: regionalDataManager = [] } = useUserListQuery({ roleId: "9" });
  const { data: fetchedRegion = [] } = useFetchRegionQuery();
  const { data: fetchedFunder = [] } = useFetchedFunderQuery();
  const indianStates: { label: string; id: string }[] =
    State.getStatesOfCountry("IN")?.map((state) => ({
      label: state.name,
      id: state.isoCode,
    })) || [];
  const { data } = useFetchManageAwardQuery();
  const {
    data: fetchedProgramTypes = { programTypes: [], programSubTypes: [] },
  } = useFetchedProgramTypesQuery();
  return (
    <Stack>
      <Tabs tabs={dummyTabCategories} handleTabChange={handleCategoryChange} />
      <SelectedTable
        isInvalidSearch={isLessThen3Value}
        selectedTab={selectedTab}
        params={params}
        onPaginationChange={handlePagination}
        onSearch={handleReportSearch}
        magicPageHeaderBtn={magicPageHeaderBtn}
        magicTableHeaderBtn={magicTableHeaderBtn}
      />
      <MagicDrawer
        title="Add Filters"
        subtitle="See the data in an organized manner by applying filters"
        drawerOpen={isOpenFilterForm}
        onDrawerToggle={toggleFilerFormDrawer}
        actionComponent={() => (
          <>
            <Button
              className="bun-outline"
              onClick={handleClearAllFilterBtn}
              // disabled={isCreatingUser}
            >
              Clear All
            </Button>
            <Button
              className="bun-filled"
              onClick={handleApplyFilterBtn}
              // loading={isCreatingUser}
            >
              Done
            </Button>
          </>
        )}
      >
        <ReportFilterForm
          selectedTab={selectedTab}
          regions={fetchedRegion}
          centerList={centerList}
          programParameters={fetchedProgramTypes.programTypes}
          qualityParameters={fetchedProgramTypes.programSubTypes}
          states={indianStates}
          city={cities}
          cityManagers={cityManager}
          clusterManagers={clusterManager}
          funders={fetchedFunder}
          regionalDataManagers={regionalDataManager}
          medals={data}
          filter={filter}
          handleFilterFormChange={handleFilterFormChange}
        />
      </MagicDrawer>
    </Stack>
  );
};

export default SummaryReportContainer;
